import { createApi } from '@reduxjs/toolkit/query/react';
import { restBaseQuery } from '../../api/rest/baseQuery';
import { appConfiguration } from '../../configuration/appConfiguration';

export const vehiclesApiTemplateSlice = createApi({
  reducerPath: 'vehiclesApi',
  baseQuery: restBaseQuery(appConfiguration.simplepay.api.url),
  endpoints: () => ({}),
});

export const {
  reducer: vehicleReducer,
  reducerPath: vehicleReducerPath,
  middleware: vehicleMiddleware,
} = vehiclesApiTemplateSlice;
